import { render, staticRenderFns } from "./VariationItem.vue?vue&type=template&id=2d5d180a&scoped=true"
import script from "./VariationItem.vue?vue&type=script&lang=js"
export * from "./VariationItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5d180a",
  null
  
)

export default component.exports